export default {
    methods: {
        decOfNum(number, titles) {
            let cases = [2, 0, 1, 1, 1, 2];
            return titles[(number % 100 > 4 && number % 100 < 20) ? 2 : cases[(number % 10 < 5) ? number % 10 : 5]];
        },
        getCsrf(){
            return $("meta[name=csrf-token]").attr("content");
        },
        removeByValue(array,value){
                var index = array.indexOf(value);

                if(index!=-1){

                    array.splice(index, 1);
                }

                return array;
            },
        in(value, array) {
                return array.indexOf(value) > -1;
            },
    }
}